<template>
  <div>
    <Modal v-model="orderSubmissionModal" :title="$t('key1001489')" class-name="orderSubmissionStyles"
      :transfer="false" :mask-closable="false" width="1000" @on-visible-change="orderSubmissionChange">
      <Form ref="orderSubmissionForm" :model="orderSubmissionForm" label-position="top" :rules="ruleValidate" @submit.native.prevent>
        <Row style="width: 90%;" class="pl40">
          <h2 class="color-333 font-size-15 mb15">{{ $t('key1001502') }}</h2>
          <!--支付选择-->
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001490')" prop="payType" class="radio_styles">
              <RadioGroup v-model="orderSubmissionForm.payType">
                <Radio class="mr45" v-for="item in paymentTypeList" :key="item.value" :label="item.value">
                  <span>{{ item.name }}</span>
                  <span class="color-999 font-size-12" v-if="item.description">{{ item.description }}</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <!--线下支付模式-->
          <div v-show="['offlinePayment', 'mixedPayment'].includes(paymentMode) && orderSubmissionForm.payType === 2">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001491')" prop="channel" class="required_style_label">
                <Select v-model="orderSubmissionForm.channel" filterable transfer style="width:300px;" @on-change="changeChannel">
                  <Option v-for="(item, index) in paymentChannelsList" :value="item.channel" :key="index">{{ item.channel }}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="orderSubmissionForm.channel">
              <FormItem :label="$t('key1001492')" prop="account">
                <div class="flex align-items-center">
                  <Select v-model="orderSubmissionForm.account" filterable transfer style="width:300px;" @on-change="changeAccount">
                    <Option v-for="(item, index) in accountList" :value="item.account" :key="index">{{ item.account }}</Option>
                  </Select>
                  <span class="ml20" :class="orderSubmissionForm.account ? 'themeColor cursor' : ''" @click="viewCompleteMessage">{{ $t('key1001503') }}</span>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="orderSubmissionForm.account">
              <FormItem :label="$t('key1001493')" prop="receiveTotalPrice">
                <div class="flex-direction">
                  <Input disabled v-model.trim="totalPayableAmount" style="width:300px;"></Input>
                  <p class="width_300 text-align-right font-size-12" v-if="orderSubmissionForm.channel && orderSubmissionForm.account">
                    {{ $t('key1001496') + orderSubmissionForm.receiveTotalPrice + ' ' + orderSubmissionForm.currency }}
                  </p>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001494')" prop="imagePaths" class="required_style_label">
                <div class="flex align-items-center">
                  <template v-if="orderSubmissionForm.imagePaths.length >0">
                    <div class="img_style" v-for="(url, index) in orderSubmissionForm.imagePaths" v-viewer="viewerOptions">
                      <img :src="setImgPath(url)" alt=""/>
                      <Icon type="ios-close-circle" class="del-icon" @click.stop="delProductImages(index)"/>
                    </div>
                  </template>
                  <Upload
                    v-if="orderSubmissionForm.imagePaths.length < 5"
                    class="upload_styles"
                    ref="upload"
                    type="drag"
                    name="files"
                    multiple
                    :headers="headObj"
                    :action="fileApi"
                    :data="uploadData"
                    :show-upload-list="false"
                    :on-success="uploadSuccess"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="5120"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize">
                    <div class="upload_icon_box">
                      <Icon type="ios-cloud-upload" size="45" style="color: #3399ff"></Icon>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                </div>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1001495')" prop="remark">
                <Input type="textarea" :showWordLimit="true" :maxlength="200"
                  :autosize="{ minRows: 4, maxRows: 6}" v-model.trim="orderSubmissionForm.remark">
                </Input>
              </Form-item>
            </Col>
            <p class="font-size-13 color-999 mb20">
              <span>{{ $t('key1000615') }}</span>
              <span>{{ $t('key1001504') }}</span>
            </p>
          </div>
          <!--在线支付模式-->
          <div v-show="['mixedPayment', 'onlinePayment'].includes(paymentMode) && orderSubmissionForm.payType === 1">
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <FormItem :label="$t('key1001493')" prop="receiveTotalPrice">
                <Input disabled v-model.trim="totalPayableAmount" style="width:300px;"></Input>
              </FormItem>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="orderAmountTag()">
              <div class="flex" v-if="amountInfo">
                <div class="availableOrderAmount_box">
                  <p>{{ $t('key1001497') + amountInfo.currency + '）' }}</p>
                  <p class="distributorThemeColor font-size-15 font-weight-bold mt5">{{ amountInfo.availableOrderAmount }}</p>
                </div>
                <p class="width_30 text-center">=</p>
                <div class="availableBalance_box">
                  <p>{{ $t('key1001498') + amountInfo.currency + '）' }}</p>
                  <p class="distributorThemeColor font-size-15 font-weight-bold mt5">{{ amountInfo.balance }}</p>
                </div>
                <p class="width_30 text-center" v-if="amountInfo.isSettingQuota">+</p>
                <div class="width_400 pl12" v-if="amountInfo.isSettingQuota">
                  <p>{{ $t('key1001499') + amountInfo.currency + '）' }}</p>
                  <p class="distributorThemeColor font-size-15 font-weight-bold mt5">{{ amountInfo.remainingCreditLimit }}</p>
                  <p class="distributorThemeColor font-size-12 mt5 mb24">
                    {{ $t('key1001500') + amountInfo.distributorInitialQuota + ' CNY )' + '  -  ' + $t('key1001501') + amountInfo.distributorUsedQuota + ' CNY )' }}
                  </p>
                </div>
              </div>
            </Col>
            <p class="font-size-13 mb20" v-if="verifyTheAmountTalg">{{ $t('key1001505') }}</p>
            <div v-else class="flex align-items-center font-size-13 flex-wrap mb20">
              <span>{{ $t('key1001506') }}</span>
              <span style="color: #FF0000;">{{ $t('key1001507') }}</span>
              <span>{{ $t('key1001508') }}</span>
              <span class="text-decoration-underline distributorThemeColor cursor" @click="clickToRecharge">{{ $t('key1001509') }}</span>
              <span>{{ $t('key1001510') }}</span>
            </div>
          </div>
        </Row>
      </Form>
      <template #footer>
        <Button @click="orderSubmissionModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="orderSubmissionBtn" :loading="orderSubmissionLoading"
          :disabled="!verifyTheAmountTalg && (['mixedPayment', 'onlinePayment'].includes(paymentMode) && orderSubmissionForm.payType === 1)"
        >{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--账户完整信息弹窗-->
    <completeAccountInfoModal ref="completeAccountInfo"></completeAccountInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {
  commonLocalStorage, getPaymentChannelsData, getCurrencyConversion,
  amountHandel, pageJump, getDistributorBalanceInfo, calculateDistributorAmount, clearFormFieldValidate
} from "@/utils/common";
import completeAccountInfoModal from "@/views/distributor/components/orderManage/completeAccountInfoModal.vue";

export default {
  name: 'orderSubmissionModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      orderSubmissionModal: false,
      orderSubmissionForm: {
        payType: 1,
        channel: null, // 支付渠道
        account: null, // 运营收款账户
        receiveTotalPrice: null, // 应付总额
        currency: null, // 币种
        imagePaths: [], // 图片路径
        remark: '', // 备注
        accountRemark: '', // 账户备注
      },
      ruleValidate: {
        channel: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001479'), trigger: 'change'}
        ],
        account: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001480'), trigger: 'change'}
        ]
      },
      orderSubmissionLoading: false,
      paymentChannelsList: [],
      accountList: [],
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      uploadData: {},
      paymentMode: 'onlinePayment', // 在线支付：onlinePayment、线下支付：offlinePayment、线下、线上支付：mixedPayment
      totalPayableAmount: null,
      detailsData: null,
      paymentTypeList: [],
      amountInfo: null,
      pendingPayment: false
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 验证可用下单金额是否充足
    verifyTheAmountTalg() {
      return this.amountInfo && Number(this.amountInfo.availableOrderAmount) >= Number(this.detailsData.totalPrice);
    }
  },
  methods: {
    // 初始化数据
    async initOrderSubmissionData(data, pendingPaymentValue) {
      // 获取支付渠道基础数据
      this.paymentChannelsList = await getPaymentChannelsData('?status=1');
      let {totalPrice, currency} = data;
      this.totalPayableAmount = totalPrice + ' ' + currency;
      this.detailsData = data;
      this.pendingPayment = pendingPaymentValue;
      await this.showOrderSubmissionModal(pendingPaymentValue);
    },
    // 根据配置项判断当前展示订单提交模态框
    showOrderSubmissionModal(pendingPaymentValue) {
      const config = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      // 是否开启线下付款
      const offlinePaymentFlag = Number(config?.offlinePayment) === 1;
      // 是否开启在线支付
      const onlineBalanceRechargeFlag = Array.isArray(config?.onlineBalanceRecharge) && config.onlineBalanceRecharge.length > 0;
      let list = [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001481'), description: ''},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001482'), description: ''},
      ]
      if (!pendingPaymentValue) {
        list.push({value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001483'), description: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001484')})
      }
      // 系统仅支持“线下付款”时
      if (offlinePaymentFlag && !onlineBalanceRechargeFlag) {
        this.paymentMode = 'offlinePayment';
        this.orderSubmissionForm.payType = 2;
        this.paymentTypeList = list.filter((item) => item.value !== 1);
        this.orderSubmissionModal = true;
        return;
      }
      // 系统仅支持“在线支付”时
      if (!offlinePaymentFlag && onlineBalanceRechargeFlag) {
        this.paymentMode = 'onlinePayment';
        this.orderSubmissionForm.payType = 1;
        this.paymentTypeList = list.filter((item) => item.value !== 2);
        this.getAvailableOrderAmount();
        this.orderSubmissionModal = true;
        return;
      }
      // 系统既支持“线下付款”，又支持“在线支付”时
      if (offlinePaymentFlag && onlineBalanceRechargeFlag) {
        this.paymentMode = 'mixedPayment';
        this.paymentTypeList = list;
        this.getAvailableOrderAmount();
        this.orderSubmissionModal = true;
        return;
      }
    },
    // 获取可用下单金额数据
    async getAvailableOrderAmount() {
      let amountData = await getDistributorBalanceInfo(this.userInfo.merchantId);
      if (amountData) {
        let obj = calculateDistributorAmount(amountData);
        // 剩余授信额度
        obj.remainingCreditLimit = amountHandel(Number(obj.distributorInitialQuota) - Number(obj.distributorUsedQuota));
        // 可用下单金额
        obj.availableOrderAmount = amountHandel(Number(obj.balance) + Number(obj.remainingCreditLimit));
        this.amountInfo = obj;
      }
    },
    // 订单提交
    orderSubmissionBtn() {
      let obj;
      const handleData = (obj, paymentVoucherInfo) => {
        // 平台订单--添加、拆分、调整YMS订单
        let platformOrderCreateOrderBoList = obj.platformOrderCreateOrderBoList || [];
        let ymsPackageInfos = obj.ymsPackageInfos || [];
        if (platformOrderCreateOrderBoList.length > 0) {
          platformOrderCreateOrderBoList.forEach((item) => {
            item.payType = this.orderSubmissionForm.payType;
            if (paymentVoucherInfo) {
              item.uploadPackagePayVoucherBo = paymentVoucherInfo;
            }
          });
        }
        // 下手工单、商城--购物车下单、立即购买
        if (ymsPackageInfos.length > 0) {
          ymsPackageInfos.forEach((item) => {
            item.payType = this.orderSubmissionForm.payType;
            if (paymentVoucherInfo) {
              item.uploadPackagePayVoucherBo = paymentVoucherInfo;
            }
          });
        }
        // 分销商--YMS订单、备货单、平台订单中YMS订单 待付款订单--继续付款
        if (this.pendingPayment) {
          obj.payType = this.orderSubmissionForm.payType;
          if (paymentVoucherInfo) {
            obj.uploadPackagePayVoucherBo = paymentVoucherInfo;
          }
        }
        // 分销商--创建备货单
        let stockPackageInfoVos = obj.stockPackageInfoVos || [];
        if (stockPackageInfoVos.length > 0) {
          obj.payType = this.orderSubmissionForm.payType;
          obj.uploadPackagePayVoucherBo = paymentVoucherInfo;
        }
        return obj;
      }
      switch (this.orderSubmissionForm.payType) {
        // 在线支付
        case 1:
          obj = handleData(this.detailsData.params.query)
          this.submitOrder(obj);
          break;
        // 线下支付
        case 2:
          this.$refs['orderSubmissionForm'].validate((valid) => {
            if (valid) {
              if (!this.orderSubmissionForm.imagePaths || this.orderSubmissionForm.imagePaths.length === 0) {
                this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001485'));
                this.orderSubmissionLoading = false;
                return;
              }
              let {payType, ...params} = this.orderSubmissionForm;
              obj = handleData(this.detailsData.params.query, params);
              this.submitOrder(obj);
            } else {
              this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001486'));
              this.orderSubmissionLoading = false;
            }
          });
          break;
        // 创建待付款订单
        case 0:
          obj = handleData(this.detailsData.params.query)
          this.submitOrder(obj);
          break;
      }
    },

    // 提取提交订单的公共方法
    async submitOrder(query) {
      let {params} = this.detailsData;
      this.orderSubmissionLoading = true;
      let text = this.orderSubmissionForm.payType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001487') :
        this.orderSubmissionForm.payType === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      try {
        this.axios.post(params.url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            this.$emit('updateOrderData', {
              text: params.text || text,
              data
            });
            this.orderSubmissionModal = false;
          }
        });
      } catch (e) {
        this.$emit('errorOrderData', e);
      } finally {
        this.orderSubmissionLoading = false;
      }
    },
    // 处理是否展示下单金额模块
    orderAmountTag() {
      const roleData = commonLocalStorage.getItem('roleData') || this.$store.state.roleData || [];
      if (!Array.isArray(roleData) || roleData.length === 0) {
        return false;
      } else {
        return roleData.includes('distributor_rechargeRecord');
      }
    },
    // 上传支付流水图片
    uploadSuccess(response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        v.orderSubmissionForm.imagePaths = [...v.orderSubmissionForm.imagePaths, response.datas[0]].slice(0, 5);
        v.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251')}`);
      } else {
        v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457')}`);
      }
    },
    // 校验文件格式
    handleFormatError(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001477')}`,
        duration: 4
      });
    },
    // 限制上传的文件不能超过5M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001478')}`,
        duration: 4
      });
    },
    // 删除图片
    delProductImages(index) {
      this.orderSubmissionForm.imagePaths.splice(index, 1);
      this.$forceUpdate();
    },
    // 选择支付渠道
    changeChannel(value) {
      this.accountList = [];
      if (value) {
        let newList = this.paymentChannelsList.filter((item) => item.channel === value);
        this.accountList = this.uniqueFunc(newList, 'account');
        this.orderSubmissionForm.account = null;
        this.orderSubmissionForm.accountRemark = '';
        if (this.accountList.length > 0) {
          this.orderSubmissionForm.account = this.accountList[0].account;
          this.orderSubmissionForm.accountRemark = this.accountList[0].remark;
          this.changeAccount(this.orderSubmissionForm.account);
        }
      }
    },
    // 选择账户
    changeAccount(value) {
      let {totalPrice, currency} = this.detailsData;
      let list = this.accountList.filter((item) => item.account === value);
      if (list.length > 0) {
        let query = {
          price: totalPrice,
          priceCurrency: currency,
          targetCurrency: list[0].currency
        };
        getCurrencyConversion(query).then((item) => {
          this.orderSubmissionForm.receiveTotalPrice = amountHandel(item.targetPrice);
          this.orderSubmissionForm.currency = item.targetCurrency;
        });
      }
    },
    // 查看完整消息
    viewCompleteMessage() {
      let list = this.accountList.filter((item) => item.account === this.orderSubmissionForm.account);
      this.$refs['completeAccountInfo'].initCompleteAccountInfoData(list[0]);
    },
    // 点击充值
    clickToRecharge() {
      localStorage.setItem('openRechargeTalg', JSON.stringify(true));
      if (this.system === 'distributor') {
        const {href} = this.$router.resolve({
          name: 'RechargeRecord'
        });
        window.open(href, '_blank');
      } else {
        pageJump(`/distributor.html#/rechargeRecord`, '/yms-distributor-service', '_blank');
      }
      this.orderSubmissionModal = false;
    },
    // 监听弹窗
    orderSubmissionChange(value) {
      if (!value) {
        this.orderSubmissionLoading = false;
        this.paymentChannelsList = [];
        this.accountList = [];
        this.totalPayableAmount = null;
        this.detailsData = null;
        this.amountInfo = null;
        this.$refs['orderSubmissionForm'].resetFields();
        this.orderSubmissionForm.accountRemark = '';
        this.pendingPayment = false;
      }
    },
  },
  watch: {
    'orderSubmissionForm.payType': {
      handler(value) {
        if (value === 2) {
          this.$nextTick(() => {
            clearFormFieldValidate(this.$refs.orderSubmissionForm, ['channel', 'account']);
          });
        }
      },
      deep: true
    }
  },
  components: {
    completeAccountInfoModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .orderSubmissionStyles {
  .upload_styles {
    .ivu-upload.ivu-upload-drag {
      width: 100px;
      height: 100px;
    }

    .upload_icon_box {
      width: 100px;
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
  }

  .img_style {
    width: 100px;
    height: 100px;
    margin-right: 12px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      display: inline-block;
      object-fit: cover;
      vertical-align: middle;
      border: 1px solid #ddd;
      border-radius: 5px;
    }

    &:hover .del-icon {
      display: block;
      z-index: 1000;
    }
  }

  .del-icon {
    font-size: 24px;
    position: absolute;
    top: -10px;
    right: -10px;
    cursor: pointer;
    display: none;

    &:hover {
      color: #ff0000;
    }
  }

  .ivu-form-item {
    .ivu-form-item-label {
      padding-right: 0 !important;
      padding-bottom: 4px !important;
    }
  }

  .radio_styles .ivu-form-item-content {
    line-height: initial;
  }

  .availableOrderAmount_box {
    min-width: 140px;
    padding-right: 10px;
  }

  .availableBalance_box {
    min-width: 120px;
    padding: 0 8px 0 15px;
  }
}
</style>
